import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { IoClose } from "react-icons/io5";

const ModalBox = ({ setShowModalBox, showModalBox, heading, description }) => {
  return (
    <>
      <Modal
        centered
        size="md"
        isOpen={showModalBox}
        toggle={() => setShowModalBox(!showModalBox)}
      >
        <div className="d-flex px-2 py-3 border-bottom">
          <h5 className="mx-auto mb-0">{heading}</h5>
          <IoClose
            className="close-icon"
            onClick={() => setShowModalBox(!showModalBox)}
          />
        </div>
        <ModalBody>
          <div className="d-flex align-items-center justify-content-center">
            <p>{description}</p>
          </div>
        </ModalBody>
        
      </Modal>
    </>
  );
};

export default ModalBox;
